/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React, { useEffect, useRef, useState } from 'react';
import { Flex, Spinner, Text } from '@chakra-ui/react';
import OptimizedJsonViewer from './optimized-json-viewer.component';

type OptimizedJsonViewerWithWorkerProps = {
  jsonString: string;
  onItemClick: any;
  searchTerm: string;
  isDisabled: boolean;
};

const OptimizedJsonViewerWithWorker: React.FC<OptimizedJsonViewerWithWorkerProps> = ({
  jsonString,
  onItemClick,
  searchTerm,
  isDisabled,
}) => {
  const [parsedData, setParsedData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const workerRef = useRef<Worker | null>(null);

  useEffect(() => {
    workerRef.current = new Worker(
      new URL('../../../../workers/jsonParserWorker.ts', import.meta.url)
    );

    workerRef.current.onmessage = function (e: MessageEvent<any>) {
      if (e.data.action === 'jsonParsed') {
        setParsedData(e.data.result);
      } else if (e.data.action === 'error') {
        setError(e.data.error);
      }
    };

    return () => workerRef.current?.terminate();
  }, []);

  useEffect(() => {
    if (jsonString && workerRef.current) {
      workerRef.current.postMessage({ action: 'parseJson', data: jsonString });
    }
  }, [jsonString]);

  if (error) {
    return (
      <div>
        Error parsing JSON:
        {error}
      </div>
    );
  }

  if (!parsedData) {
    return (
      <Flex
        minHeight="30vh"
        maxHeight="50vh"
        w="full"
        direction="column"
        gap={2}
        alignItems="center"
        justifyContent="center"
      >
        <Spinner />
        <Text>Parsing JSON...</Text>
      </Flex>
    );
  }

  return (
    <OptimizedJsonViewer
      data={parsedData}
      onItemClick={onItemClick}
      searchTerm={searchTerm}
      isDisabled={isDisabled}
    />
  );
};

export default OptimizedJsonViewerWithWorker;
